module.exports = __webpack_public_path__ + "static/media/3D-district-top.fd4f40dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/3D-district-top.jpg
// module id = 140
// module chunks = 0